import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import EditBlockquote from '@wikifactory/slate-edit-blockquote';

import { NodeHotKey } from 'libs/editor/plugins/helpers/nodeHotKey';
import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';

const QuoteNode = observer(({ attributes, children }) => (
  <QuoteStyle {...attributes}>{children}</QuoteStyle>
));

// TODO: Move these into a styles.js file
const QuoteStyle = styled.blockquote`
  box-shadow: -2px 0 0 0 rgba(0, 0, 0, 1);
  padding: 8px 12px;
  font-style: italic;
  margin: 10px 20px;
`;

const type = 'blockquote';
const quotePlugin = EditBlockquote();
const active = value => quotePlugin.utils.isSelectionInBlockquote(value);

export function Quote() {
  return {
    button: {
      elementType: 'node',
      type: 'blockquote',
      active,
      handleClick: store => {
        const { value, reference, onChange } = store;
        if (active(value)) {
          quotePlugin.changes.unwrapBlockquote(reference);
        } else {
          quotePlugin.changes.wrapInBlockquote(reference);
        }
        onChange(reference);
      },
    },
    plugins: [
      NodeHotKey({ key: '>', type }),
      RenderNode(type, props => <QuoteNode {...props} />),
      quotePlugin,
    ],
  };
}
